import { useQuery } from '@tanstack/react-query';
import { usageApi } from '../lib/api';

export interface UsageByModel {
  model: string;
  calls: number;
  input_tokens: number;
  output_tokens: number;
}

export interface UsageByDay {
  day: string;
  calls: number;
  input_tokens: number;
  output_tokens: number;
}

export interface UsageSummary {
  tenant: string;
  total_calls: number;
  total_input_tokens: number;
  total_output_tokens: number;
  by_model: UsageByModel[];
  by_day: UsageByDay[];
}

export function useUsage(from?: string, to?: string) {
  return useQuery({
    queryKey: ['usage', from ?? null, to ?? null],
    queryFn: async () => {
      const res = await usageApi.get(from, to);
      return res as UsageSummary;
    },
  });
}
